import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment } from 'react';
import { PanelItemDivider } from '../../../../panels/panelItemDivider';
import { useAppSelector } from '../../../../redux/store';
import { SIDE_BETS_PANEL_BACKGROUND_COLOR } from '../../../../styles/colors';
import { range } from '../../../../utils/utils';
import { SideBetItem } from './sideBetItem';
const CONTAINER_CSS = css `
  width: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
`;
export const SideBetItemsContainer = () => {
    const numSideBetItems = useAppSelector((state) => state.sideBets.sideBetItems.length);
    return (_jsx("div", { css: CONTAINER_CSS, "aria-label": 'placed side bets', children: range(numSideBetItems).map((i) => (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: SIDE_BETS_PANEL_BACKGROUND_COLOR, thicknessPx: 2 }), _jsx(SideBetItem, { itemIndex: i })] }, i))) }));
};
